var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23 32.8c-1.56 0-2.825-1.255-2.825-2.8s1.266-2.8 2.825-2.8c1.56 0 2.825 1.255 2.825 2.8-.098 1.545-1.364 2.8-2.825 2.8zm-2.018-18.628C20.982 12.944 21.86 12 23 12c1.14 0 2.018.944 2.018 2.172v9.161c0 1.228-.878 2.267-2.018 2.267-1.14 0-2.018-1.039-2.018-2.267v-9.16zm24.257 17.62L27.765 2.642C26.721.943 25.012 0 23.017 0c-1.994 0-3.702.943-4.748 2.642L.796 31.792C-.25 33.491-.25 35.566.7 37.264 1.65 39.057 3.455 40 5.545 40H40.49c1.995 0 3.799-1.038 4.843-2.736.95-1.698.855-3.773-.094-5.472z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5abbb124da375685552ed1a09028bab2.svg";
export { ForwardRef as ReactComponent };